import React from 'react';
import styled from 'styled-components';
import { Styles } from '../../config';

import { Icon, SVG, Typography } from '../../typo-components';

const Button = styled.button`
  display: grid;
  grid-template-columns: 30% 70%;
  width: 100%;
  height: 64px;
  background: transparent;
  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  padding: 5px 20px;
  cursor: pointer;
  color: ${(props) =>
    props.color ? Styles.Color[props.color] : Styles.Color.primary};

  &:disabled {
    color: ${Styles.Color.lightgray}!important;
    cursor: default;
  }

  &:disabled * {
    color: ${Styles.Color.lightgray}!important;
    fill: ${Styles.Color.lightgray}!important;
    align-self-center;
  }

  & * {
      justify-self: flex-start;
      align-self: center;
  }



 
  &:not([disabled]):hover {
    background: rgba(0, 0, 0, 0.04);

  }

`;

const MenuItemButton = (props) => {
  return (
    <Button onDoubleClick={() => false} {...props}>
      {props.iconType === 'icon' || !props.iconType ? (
        <Icon
          variant={props.variant}
          size={props.size || 'medium'}
          color={props.color || 'primary'}
          provider={props.provider}
          name={props.icon}
        ></Icon>
      ) : (
        <SVG name={props.icon} color={props.color} size={props.size}></SVG>
      )}
      <Typography
        textAlign="left"
        color={props.color || 'primary'}
        variant="t6"
      >
        {props.children}
      </Typography>
    </Button>
  );
};

export default MenuItemButton;
